module.exports = __webpack_public_path__ + "img/logo-polki25-1-trimmed.png";